import React, { Component } from "react";
import { connect } from "react-redux";
import { change, submit, isSubmitting } from "redux-form";
import {
    fetchEnd,
    fetchStart,
    showNotification,
    SimpleForm,
    FileInput,
    ChipField,
    crudGetMatching,
    CREATE,
    // GET_ONE,
    REDUX_FORM_NAME
} from "react-admin";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import IconCancel from "@material-ui/icons/Cancel";
import IconSave from "@material-ui/icons/Save";
import CircularProgress from "@material-ui/core/CircularProgress";
import UploadIcon from "@material-ui/icons/CloudUpload";
import TranslatedText from "./TranslatedText";
import restClient from "../common/restClient";

const MY_FORM_NAME = "form-upload-file";

class UploaderToolButton extends Component {
    state = {
        error: false,
        showDialog: false,
        fileLoaded: false,
        showLoading: false
    };
    handleClick = e => {
        e.preventDefault();
        this.setState({ showDialog: true });
    };
    handleCloseClick = () => {
        this.setState({ showDialog: false, showLoading: false });
    };
    handleSaveClick = () => {
        const { submit } = this.props;
        this.setState({ fileLoaded: false, showLoading: true });
        // Trigger a submit of our custom quick create form
        // This is needed because our modal action buttons are oustide the form
        submit(`${MY_FORM_NAME}_${this.props.id}`);
    };

    handleSubmit = values => {
        const { change, fetchStart, fetchEnd, showNotification } = this.props;
        // Dispatch an action letting react-admin know a API call is ongoing
        fetchStart();

        // encode file in base654
        if (values.files) {
            const reader = new FileReader();
            reader.readAsDataURL(values.files.rawFile);
            reader.onloadend = () => {
                const base64data = reader.result.split(",")[1];

                /*
                // check file_name
                restClient(GET_ONE, "utilities", { id: this.props.id }).then(
                    response => {
                        if (
                            response &&
                            response.data &&
                            response.data.file_name !==
                                values.files.rawFile.name
                        ) {
                            showNotification("file_name_error", "error");
                            this.setState({
                                error: true,
                                showLoading: false,
                                fileLoaded: false
                            });
                            return null;
                        }
                */
                restClient(CREATE, "utilities", {
                    data: { id: this.props.id, url: base64data }
                })
                    .then(({ data }) => {
                        // Update the main react-admin form (in this case, the comments creation form)
                        change(REDUX_FORM_NAME, "post_id", data.id);
                        showNotification(data.message, "info");
                        this.props.updateUrlFunction(base64data);
                        this.setState({
                            showLoading: false,
                            showDialog: false
                        });
                    })
                    .catch(error => {
                        showNotification("file_not_loaded", "error");
                    })
                    .finally(() => {
                        // Dispatch an action letting react-admin know a API call has ended
                        fetchEnd();
                    });
                /*
                    },
                    err => {
                        showNotification("file_not_loaded", "error");
                        console.log(err);
                        return null;
                    }
                );
                */
            };
        } else {
            showNotification("file_not_loaded", "error");
        }
    };

    render() {
        const { showDialog } = this.state;
        const { isSubmitting } = this.props;
        return (
            <span>
                <Button
                    color="primary"
                    onClick={this.handleClick}
                    href="#"
                    target="self"
                >
                    <UploadIcon />
                    <span
                        style={{
                            paddingLeft: "0.5em",
                            position: "relative",
                            top: 3
                        }}
                    >
                        UPLOAD
                    </span>
                </Button>
                <Dialog
                    key={`uploader_dialog_${this.props.id}`}
                    fullWidth
                    open={showDialog}
                    onClose={this.handleCloseClick}
                    disableBackdropClick
                    disableEscapeKeyDown
                >
                    <DialogContent>
                        <SimpleForm
                            key={`uploader_form_${this.props.id}`}
                            // We override the redux-form name to avoid collision with the react-admin main form
                            form={`${MY_FORM_NAME}_${this.props.id}`}
                            resource="posts"
                            // We override the redux-form onSubmit prop to handle the submission ourselves
                            onSubmit={this.handleSubmit}
                            // We want no toolbar at all as we have our modal actions
                            toolbar={null}
                        >
                            <FileInput
                                source="files"
                                accept={this.props.file_mime_type}
                                label=""
                                options={{
                                    onDropAccepted: () => {
                                        this.setState({ fileLoaded: true });
                                    }
                                }}
                            >
                                <ChipField source="title" title="title" />
                            </FileInput>
                        </SimpleForm>
                    </DialogContent>

                    <DialogActions>
                        <Button
                            disabled={!this.state.fileLoaded}
                            saving={isSubmitting.toString()}
                            onClick={this.handleSaveClick}
                        >
                            {this.state.showLoading ? (
                                <CircularProgress />
                            ) : (
                                <IconSave />
                            )}

                            <span style={{ paddingLeft: "0.5em" }} />
                            <TranslatedText resource_name="ra.action.save" />
                        </Button>
                        {
                            <Button
                                variant="contained"
                                onClick={this.handleCloseClick}
                            >
                                <IconCancel />
                                <span style={{ paddingLeft: "0.5em" }} />
                                <TranslatedText resource_name="ra.action.cancel" />
                            </Button>
                        }
                    </DialogActions>
                </Dialog>
            </span>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    isSubmitting: isSubmitting(`${MY_FORM_NAME}_${ownProps.id}`)(state)
});
const mapDispatchToProps = {
    change,
    fetchEnd,
    fetchStart,
    showNotification,
    crudGetMatching,
    submit
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UploaderToolButton);



// WEBPACK FOOTER //
// ./src/components/UploaderToolButton.js